import { CHARACTER_MODERATION_STATUS, CHARACTER_VISIBILITY } from "@next-platform/client-common-core";

export enum MembersGroupChatDisplayMode {
  NORMAL = "normal",
  EDITABLE = "editable",
}

export interface GroupMembersChatBot {
  id: string;
  name: string;
  avatar: string;
  avatarIsNsfw?: boolean;
  visibility: CHARACTER_VISIBILITY;
  hasError: boolean;
  moderation_status?: CHARACTER_MODERATION_STATUS;
  creator_username?: string;
}
